import React from "react";

const FAQ = ({ onClose }) => {
  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "12px",
        maxHeight: "70vh",
      }}
    >
      {/* Optionaler Close-Button für Modals */}
      {onClose && (
        <button
          onClick={onClose}
          style={{
            float: "right",
            border: "none",
            background: "transparent",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ×
        </button>
      )}

      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#1b96e3",
          marginBottom: "1rem",
        }}
      >
        Frequently Asked Questions
      </h1>

      <div style={{ lineHeight: "1.6", color: "#333" }}>
        <section style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.3rem" }}>
            Is Bambkuss Active for free?
          </p>
          <p style={{ margin: 0 }}>Yes, the registration and the chat are for free!</p>
        </section>

        <section style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.3rem" }}>
            What are Bambkuss's requirements?
          </p>
          <p style={{ margin: 0 }}>
            The only requirement Bambkuss has for sending requests or writing to
            users is that you upload at least one photo to your profile.
          </p>
        </section>

        <section style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.3rem" }}>
            Does Bambkuss offer premium features that require payment?
          </p>
          <p style={{ margin: 0 }}>Yes, but these have not yet been released.</p>
        </section>

        <section style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.3rem" }}>
            Can I permanently delete my profile?
          </p>
          <p style={{ margin: 0 }}>
            Yes, if you want, your profile will be deleted immediately and
            permanently.
          </p>
        </section>

        <section style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.3rem" }}>
            Is it possible to upload videos on Bambkuss Active?
          </p>
          <p style={{ margin: 0 }}>No, it is only possible to upload photos.</p>
        </section>

        <section style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.3rem" }}>
            Where was Bambkuss Active invented and developed?
          </p>
          <p style={{ margin: 0 }}>In Bremen, Germany.</p>
        </section>
      </div>
    </div>
  );
};

export default FAQ;
